'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.associateFileIdsWithThreadClient = undefined;

var _noAuthApiClient = require('../../http/noAuthApiClient');

var _noAuthApiClient2 = _interopRequireDefault(_noAuthApiClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ASSOCIATE_ATTACHMENT_PATH = 'livechat/v1/attachment/map/thread';

var associateFileIdsWithThreadClient = exports.associateFileIdsWithThreadClient = function associateFileIdsWithThreadClient(_ref) {
  var fileIds = _ref.fileIds,
      sessionId = _ref.sessionId,
      threadId = _ref.threadId;

  return _noAuthApiClient2.default.post(ASSOCIATE_ATTACHMENT_PATH + '/' + threadId, {
    data: fileIds,
    query: {
      sessionId: sessionId
    }
  });
};